import Axios from "axios";
import {
  SET_COLLEGE_USER_LOGGED_IN,
  UNSET_COLLEGE_USER_LOGGED_IN,
  SET_AUTH_COLLEGE_USER,
  UNSET_AUTH_COLLEGE_USER,
  SET_COLLEGE_USER_TOKEN,
  UNSET_COLLEGE_USER_TOKEN,
  SET_COLLEGE_USER_PROFILE,
  UNSET_COLLEGE_USER_PROFILE,
  SET_COLLEGE_USER_CURRENT_PRIVILEGE,
  UNSET_COLLEGE_USER_CURRENT_PRIVILEGE,
  SET_SNACKBAR,
  GET_ERROR_LOG_MSG,
} from "../mutation-types";

import {
  collegeUserLoginUrl,
  logoutCollegeUserUrl,
  getCollegeUserProfileUrl,
  frontendBaseUrl,
  sendCollegeUserEmail,
  resetCollegeUserPassword,
  checkCollegeUserResetPasswordTime,
} from '../api'
import { updateMsg } from '../erpUtil'
import { resolve } from "path";
import { reject } from "lodash";

// initial state
const state = {
  errorLogMsg: {},
  CollegeUserLoggedIn: false,
  collegeUserToken: "",
  authCollegeUser: {},
  profile: {},
  currentPrivilege: null
};

const getters = {
  getErrorLog(state) {
    return state.errorLogMsg;
  },
  // getAuthStudentToken(state) {
  //     let access_token = localStorage.getItem("college_token")
  //     state.studentToken = access_token
  //     return access_token;
  // },
  getAuthCollegeUser(state) {
    let authCollegeUser = JSON.parse(localStorage.getItem("college-user"));
    state.authCollegeUser = authCollegeUser;
    return state.authCollegeUser ? state.authCollegeUser : authCollegeUser;
  },
  getCollegeUserToken(state) {
    return state.collegeUserToken;
  },
  getCollegeUserProfile(state) {
    return state.profile;
  },
  getCollegeUserCurrentPrivilege(state) {
    let currentPrivilege = JSON.parse(
      localStorage.getItem("current-privilege")
    );
    return state.currentPrivilege ? state.currentPrivilege : currentPrivilege;
  }
};
const mutations = {
  [GET_ERROR_LOG_MSG](state, errorLogMsg) {
    state.errorLogMsg = errorLogMsg;
  },
  [SET_COLLEGE_USER_LOGGED_IN](state) {
    state.CollegeUserLoggedIn = true;
  },
  [UNSET_COLLEGE_USER_LOGGED_IN](state) {
    state.CollegeUserLoggedIn = false;
  },
  [SET_AUTH_COLLEGE_USER](state, user) {
    state.authCollegeUser = user;
  },
  [UNSET_AUTH_COLLEGE_USER](state) {
    state.authCollegeUser = {};
  },
  [SET_COLLEGE_USER_TOKEN](state, token) {
    let cu_token = localStorage.getItem("token");
    state.collegeUserToken = cu_token;
  },
  [UNSET_COLLEGE_USER_TOKEN](state) {
    state.collegeUserToken = "";
  },
  [SET_COLLEGE_USER_PROFILE](state, profile) {
    state.profile = profile;
  },
  [UNSET_COLLEGE_USER_PROFILE](state) {
    state.profile = {};
  },
  [SET_COLLEGE_USER_CURRENT_PRIVILEGE](state, currentPrivilege) {
    state.currentPrivilege = currentPrivilege;
  },
  [UNSET_COLLEGE_USER_CURRENT_PRIVILEGE](state) {
    state.currentPrivilege = null;
  }
  // [SET_AUTH_COLLEGE_ACADEMIC_INFO](state, student_academic_info) {
  //     state.student_academic_info = student_academic_info
  // },
  // [UNSET_AUTH_COLLEGE_ACADEMIC_INFO](state) {
  //     state.student_academic_info = "";
  // },
};

const actions = {
  // setAcademicInfo({ commit }, authStudent) {
  //     let url = `${API_END_POINT}student/me`
  //     return new Promise((resolve, reject) => {
  //         commit("SET_LOADING", { color: "primary" });
  //         Axios.post(url)
  //             .then(function (response) {
  //                 let student = response.data.data;
  //                 let student_academic_info = response.data.data.student_academic_info;
  //                 localStorage.setItem("student", JSON.stringify(student));
  //                 localStorage.setItem("student_academic_info", JSON.stringify(student_academic_info));

  //                 commit("SET_AUTH_STUDENT", student);
  //                 commit("SET_AUTH_COLLEGE_ACADEMIC_INFO", student_academic_info);
  //                 resolve();
  //             })
  //             .catch(function (error) {
  //                 commit("SET_AUTH_STUDENT", authStudent);
  //                 commit("UNSET_AUTH_COLLEGE_ACADEMIC_INFO");
  //                 reject();
  //             })
  //             .then(always => {
  //                 commit("UNSET_LOADING");
  //             });
  //     })
  // },
  sendCollegeUserEmail({ commit, state }, data) {
    return new Promise(function (resolve, reject) {
      var params = new URLSearchParams();
      params.append("username", data.username);
      params.append("base_url", frontendBaseUrl);

      Axios.post(sendCollegeUserEmail, params)
        .then(function (response) {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
    })
  },
  resetCollegeUserPassword({ commit, state }, data) {
    return new Promise(function (resolve, reject) {
      Axios.post(resetCollegeUserPassword + '/' + data.reset_code, data)
        .then(function (response) {
          if (response.data.status === "success") {
            resolve(response);
          } else {
            resolve(response);
          }
        }).catch(error => {
          reject(error);
          return error;
        });
    });
  },
  checkCollegeUserResetPasswordTime({ commit, state }, data) {
    return new Promise(function (resolve, reject) {
      Axios.get(checkCollegeUserResetPasswordTime + '/' + data.reset_code, data)
        .then(function (response) {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
    });
  },
  // loginCollegeUser({ commit }, user) {
  //   var params = new URLSearchParams();
  //   localStorage.clear();
  //   commit("SET_LOADING", { color: "primary" });
  //   commit("UNSET_COLLEGE_USER_CURRENT_PRIVILEGE");
  //   params.append("username", user.username);
  //   params.append("password", user.password);
  //   params.append("captcha_answer", user.captcha);
  //   params.append("captcha_key", user.key);
  //   return new Promise((resolve, reject) => {
  //     Axios.post(collegeUserLoginUrl, params)
  //       .then(function (response) {
  //         var token = response.data.access_token;
  //         var expires = response.data.expires_in;
  //         var collegeUser = response.data.college;

  //         localStorage.setItem("guard", true);
  //         localStorage.setItem("token", token);
  //         localStorage.setItem("college-user", JSON.stringify(collegeUser));
  //         localStorage.setItem("cu-expires", expires);
  //         commit("SET_COLLEGE_USER_LOGGED_IN");
  //         commit("SET_AUTH_COLLEGE_USER", collegeUser);
  //         commit("SET_COLLEGE_USER_TOKEN", token);
  //         resolve();
  //       })
  //       .catch(function (error) {
  //         localStorage.removeItem("token");
  //         localStorage.removeItem("cu-expires");

  //         commit("UNSET_COLLEGE_USER_LOGGED_IN");
  //         commit("UNSET_AUTH_COLLEGE_USER");
  //         commit("UNSET_COLLEGE_USER_TOKEN");

  //         reject();
  //       })
  //       .then(always => {
  //         commit("UNSET_LOADING");
  //       });
  //   });
  // },

  loginCollegeUser({ commit }, user) {
    var params = new URLSearchParams();
    params.append("username", user.username);
    params.append("password", user.password);
    params.append("captcha_answer", user.captcha);
    params.append("captcha_key", user.key);

    commit("SET_LOADING", { color: "primary" });
    commit("UNSET_COLLEGE_USER_CURRENT_PRIVILEGE");

    return new Promise((resolve, reject) => {
      Axios.post(collegeUserLoginUrl, params, {
        validateStatus: function () {
          return true; // always go to .then(), never trigger .catch() for HTTP errors
        },
      })
        .then(function (response) {
          commit("UNSET_LOADING");
          console.log("LOGIN RESPONSE:", response.data);

          var data = response.data;
          var isError =
            (data && data.success && data.success === "error") ||
            (response.status !== 200);

          if (isError) {
            commit("GET_ERROR_LOG_MSG", data || "Login failed");

            var msg = "Login failed";
            if (data && data.message) {
              msg = data.message;
            }
            if (data && data.errors) {
              msg = Object.values(data.errors)[0][0];
            }

            commit("SET_SNACKBAR", { msg: msg, color: "red" });
            reject(response);
            return;
          }

          // Success — only clear and populate localStorage here
          var token = data.access_token;
          var expires = data.expires_in;
          var collegeUser = data.college;

          localStorage.clear();
          localStorage.setItem("guard", true);
          localStorage.setItem("token", token);
          localStorage.setItem("college-user", JSON.stringify(collegeUser));
          localStorage.setItem("cu-expires", expires);

          commit("SET_COLLEGE_USER_LOGGED_IN");
          commit("SET_AUTH_COLLEGE_USER", collegeUser);
          commit("SET_COLLEGE_USER_TOKEN", token);
          commit("SET_SNACKBAR", {
            msg: data.message || "Login successful",
            color: "green",
          });

          resolve(response);
        })
        .catch(function (error) {
          // Only real network errors (timeout, no connection) reach here
          commit("UNSET_LOADING");

          var msg = "Network error occurred";
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msg = error.response.data.message;
          }

          commit("SET_SNACKBAR", { msg: msg, color: "red" });
          reject(error);
        });
    });
  },

  logoutCollegeUser({ commit, state }) {
    commit("SET_LOADING", {
      color: "primary"
    });
    let Authorization = `Bearer ${state.collegeUserToken}`;
    return new Promise((resolve, reject) => {
      // console.log(state)
      Axios.post(
        logoutCollegeUserUrl,
        {},
        {
          headers: {
            Authorization: Authorization
          }
        }
      );
      localStorage.removeItem("token");
      localStorage.removeItem("cu-expires");
      localStorage.removeItem("college-user");
      localStorage.removeItem("guard");
      localStorage.removeItem("current-privilege");
      localStorage.clear();
      commit("UNSET_COLLEGE_USER_LOGGED_IN");
      commit("UNSET_AUTH_COLLEGE_USER");
      commit("UNSET_COLLEGE_USER_TOKEN");
      commit("UNSET_COLLEGE_USER_CURRENT_PRIVILEGE");
      commit("UNSET_LOADING");
      resolve();
    });
  },
  getCollegeUserProfile({ commit, state }) {
    commit("SET_LOADING", {
      color: "primary"
    });
    var params = new URLSearchParams();
    return new Promise((resolve, reject) => {
      Axios.get(getCollegeUserProfileUrl)
        .then(res => {
          commit("SET_COLLEGE_USER_PROFILE", res.data.data);
        })
        .catch(error => {
          // commit("UNSET_COLLEGE_USER_TOKEN");
        })
        .then(always => {
          commit("UNSET_LOADING");
        });
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
